import { ModulosMotivoENUM } from '@/shared';
import ComentariosBitacoraDialog from '@/shared/components/ui/ComentariosBitacoraDialog/ComentariosBitacoraDialog';
import BitacoraDialog from '@/shared/components/ui/CrearBitacoraDialog/CrearBitacoraDialog';
import { useDiccionarioMotivo } from '@/store/erp/diccionario_motivo/diccionario_motivo.store';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export type AdministracionModuleProps = {};

const AdministracionModule: React.FC<AdministracionModuleProps> = () => {

  (async () => {
    await Promise.all([
      // getDocumentTypes(),
      // getCountries({ page_size: 1000 }),
      // getProvinces({ page_size: 6000 }),
      // getZones({ page_size: 6000 }),
      // getPlans({ page_size: 1000 }),
      // getSectors({ page_size: 6000 }),
      // getFlotas({ page_size: 6000 }),
      // getTypeService({ page_size: 1000 }),
      // getIpv4Groups({ page_size: 1000 }),
      // getIpv6Groups({ page_size: 1000 }),
      // getVelocidades({ page_size: 1000 }),
      // getPlanTypes({ page_size: 1000 }),
      // getCities({ page_size: 6000 }),
      // getRecurrencias({ page_size: 1000 }),
      // getPaymentMethods({ page_size: 100 }),
    ]);
  })();


  ///* socket
  /* const onAlertaBitacora = useDiccionarioMotivo().onAlertaBitacora
  const onErrorBitacora = useDiccionarioMotivo().onErrorBitacora */
  const emitRegistrarUsuario = useDiccionarioMotivo().emitRegistrarUsuario
  const setDepartamento = useDiccionarioMotivo().setDepartamento
  const socket = useDiccionarioMotivo().socket


  useEffect(() => {
    setDepartamento(ModulosMotivoENUM.BITACORA_PYL)
    emitRegistrarUsuario()
    
  }, [socket])


  return (
    <>
      <Outlet />
      <ComentariosBitacoraDialog />
      {/* <ComentariosBitacoraDialogRead /> */}
      <BitacoraDialog />
    </>
  );
};

export default AdministracionModule;
